import ApiService from '@/core/services/ApiService';
import { StoreError, ReferenceRequestModuleStore } from '@/models/StoreModel';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {
  Actions,
  Getters,
  Mutations,
} from '@/store/enums/ReferenceRequestEnums';
import { ReferenceRequest } from '@/models/ReferenceRequestModel';

@Module
export default class ReferenceRequestModule
  extends VuexModule
  implements ReferenceRequestModuleStore
{
  actionError: StoreError | null = null;

  allReferenceRequests = [];
  referenceRequest = {} as unknown as ReferenceRequest;
  referenceRequests = [];

  requestError: StoreError | null = null;
  requestLoading = false;

  tenantReference = {};
  /**
   * Get current error for the resource actions
   * @returns resource action error
   */
  get [Getters.GET_ACTION_ERROR](): StoreError {
    return this.actionError as unknown as StoreError;
  }

  get [Getters.GET_TENANT_REFERENCE](): any {
    return this.tenantReference;
  }

  get [Getters.GET_REFERENCES_LISTS](): any {
    return this.referenceRequests;
  }

  @Mutation
  [Mutations.SET_ACTION_ERROR](actionError) {
    this.actionError = actionError;
  }

  @Mutation
  [Mutations.SET_TENANT_REFERENCE](data) {
    this.tenantReference = data;
  }

  @Mutation
  [Mutations.SET_REFERENCES](data) {
    this.referenceRequests = data;
  }

  @Action
  [Actions.SEND_REQUEST_TENANT_REFERENCE](payload) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post('admin/tenants/reviews/requests', payload)
        .then(() => {
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ACTION_ERROR, response.data);
          reject();
        });
    });
  }

  @Action
  [Actions.CHECK_TENANT_REFERENCE](payload) {
    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/tenants/reviews/requests/${payload.id}`)
        .then((response) => {
          this.context.commit(Mutations.SET_TENANT_REFERENCE, response.data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ACTION_ERROR, response.data);
          reject();
        });
    });
  }

  @Action
  [Actions.FETCH_REFERENCES](payload) {
    return new Promise<void>((resolve, reject) => {
      ApiService.parameters(payload);
      ApiService.get(`admin/references`)
        .then((response) => {
          this.context.commit(Mutations.SET_REFERENCES, response.data.data);
          resolve();
        })
        .catch(({ response }) => {
          reject();
        });
    });
  }

  @Action
  [Actions.REMOVE_STORED_REFERENCE]() {
    localStorage.removeItem('tenantRequestReference');
  }
}
